/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface UpdateSiteContactRequestSiteContact
 */
export interface UpdateSiteContactRequestSiteContact {
  /**
   *
   * @type {string}
   * @memberof UpdateSiteContactRequestSiteContact
   */
  expiredOn?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSiteContactRequestSiteContact
   */
  canViewable?: boolean
}

export function UpdateSiteContactRequestSiteContactFromJSON(json: any): UpdateSiteContactRequestSiteContact {
  return UpdateSiteContactRequestSiteContactFromJSONTyped(json, false)
}

export function UpdateSiteContactRequestSiteContactFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateSiteContactRequestSiteContact {
  if (json === undefined || json === null) {
    return json
  }
  return {
    expiredOn: !exists(json, 'expired_on') ? undefined : json['expired_on'],
    canViewable: !exists(json, 'can_viewable') ? undefined : json['can_viewable']
  }
}

export function UpdateSiteContactRequestSiteContactToJSON(value?: UpdateSiteContactRequestSiteContact | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    expired_on: value.expiredOn,
    can_viewable: value.canViewable
  }
}
